module.exports = __webpack_public_path__ + "img/pointB_gr1_menulist_mob.08b13f22.png";